import styled, { css } from "styled-components"
import SearchResult from "./search-result"

const Popover = css`
  max-height: 50vh;
  overflow: scroll;
  -webkit-overflow-scrolling: touch;
  position: relative;
  z-index: 2;
  right: 0;
  top: 100%;
  margin-top: 0.5em;
  width: 100%;
  box-shadow: none;
  padding: 1em;
  border-radius: 0px;
  background: transparent;
  --mask: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 1) 0,
    rgba(0, 0, 0, 1) 40%,
    rgba(0, 0, 0, 0) 95%,
    rgba(0, 0, 0, 0) 0
  ) 100% 50% / 100% 100% repeat-x;
  -webkit-mask: var(--mask);
  mask: var(--mask);
`

export default styled(SearchResult)`
  display: ${props => (props.show ? `block` : `none`)};
  ${Popover}


  .HitCount {
    display: flex;
    justify-content: flex-end;
    color: rgba(255,2555,255,.6);
  }

  .Hits {
    ol {
      list-style: none;
      margin-left: 0;
      padding-left: 1.25rem;
    }

    li.ais-Hits-item {
      margin-bottom: 1.5rem;

      a {
        color: rgba(255,255,255,.8);

        h4 {
          margin-top: 0;
          margin-bottom: 0.2em;
          font-size: 1.25rem;
        }
      }

      .search-description {
        color: rgba(255,255,255,.65);
        font-family: "Source Sans Serif", sans-serif;
      }

      &:last-of-type {
        padding-bottom: 2rem;
      }
    }
  }

  .ais-PoweredBy {
    display: flex;
    justify-content: flex-end;
    font-size: 80%;

    svg {
      width: 130px;
    }
  }
`